import axios from "axios";
import config from "../../config";
import _ from "underscore";
import {
    extractOptionFromBC,
    extractStyleAssemblyCollectionsMapFromConfig,
    prepareShopifyUrl,
    isSearchUrl,
    getCookie,
    canSeeFirstLook,
    authCheck,
    setCookie,
    vipPreviewTimers,
} from "../common/utils"
import appErrorLogger from "../common/DataDogErrorLog";
import {
    getBuildGroupByPayload, getGroupBySortObject,
    groupByUpdateFilters,
    memoizedGetParamsString, sendPlpGroupBySearchEvent,
} from "../PLP/helpers"
import { mapGroupBySearch, mapGroupBySearchOld } from "../Header/helpers";
import { ModelProductList } from "../common/ModelProductList";
import appInfoLogger from "../common/DataDogInfoLog";
import { getProductsByTag } from "./cart"
import { filterForYouProducts, mapForYouProductsAndFilters } from "../ForYouPLP/helpers"
import { setUserProfile } from "./myAccountAC"

const rebag_filter_instance = axios.create({
    baseURL: `${config.host_rebag_api}/v6/shop/filter/`,
    timeout: 30000,
});

const rebag_products_instance = axios.create({
    baseURL: `${config.host_rebag_api}/v6/shop/product/`,
    timeout: 30000,
});

const groupByInstance = axios.create({
    baseURL: "https://proxy.rebag.groupbycloud.com/rebag/api/search/",
    timeout: 30000,
    headers: {
        'x-application-type': 'search',
        'Content-Type': 'application/json'
    }
})

const autocompleteGroupByInstance = axios.create({
    baseURL: "https://proxy.rebag.groupbycloud.com/rebag/api/request/",
    timeout: 30000,
    headers: {
        'x-application-type': 'autocomplete',
        'Content-Type': 'application/json'
    }
})

const authenticatedAxios = () => {
    const auth_token = getCookie('auth_token');
    const is_b2b = getCookie('is_b2b');
    return axios.create({
        baseURL: `${config.host_rebag_api}/v6`,
        timeout: is_b2b ? 120000 : 45000,
        headers: {'Authorization': auth_token}
    });
};

const item_limit = window.innerWidth <= 768 ? 4 : 14;
let cancelSearchPreviousRequest;
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const getSimilar = (query, product_id, event_type) => {
    return (dispatch, getState) => {
        const api_client = getState().appReducer.isBoostDown ? rebag_products_instance : groupByInstance;
        // const query = "pf_v_designers=Chanel&pf_st_availability_hidden=true";
        const queryArray =  decodeURIComponent(query).replaceAll('[]', '').split('&');
        const data = {
            collection: config.gb_collection,
            area: config.gb_area,
            skip: "0",
            query: '',
            refinements: [],
            sorts: [],
            preFilter: "attributes.publishedOnChannel:ANY(\"true\") AND availability:ANY(\"IN_STOCK\") AND NOT attributes.tags:ANY(\"pfs:hidden\")",
            pageCategories: ["new-arrivals"],
            pageSize: item_limit
        }
        queryArray.forEach(item => {
          const [filterId, filterValue] = item.split('=');
          if (filterId === 'pf_st_availability_hidden') {
              return
          }

          if (filterId === 'q') {
              data.query = filterValue;
              return
          }

          if (filterId === 'pf_t_first_look_hidden') {
              data.preFilter += ` AND attributes.pf_t_first_look_hidden:ANY("${filterValue}")`;
              return
          }

          if (filterId === 'h_options') {
              data.preFilter += ` AND NOT attributes.tags:ANY("${filterValue}")`;
              return
          }

          data.refinements.push({
            displayName: filterValue,
            navigationName: `attributes.${filterId}`,
            or: "true",
            type: "Value",
            value: filterValue,
          })
        })
        api_client.post('', JSON.stringify(data))
            .then((response) => {
                const {records, totalRecordCount} = response.data;
                if(totalRecordCount > 0){
                    const filtered_products = removeCurrent(records, product_id);
                    if(filtered_products.length > 0){
                        dispatch({
                            type: event_type,
                            products: ModelProductList(filtered_products.slice(0, item_limit)),
                            total_products: totalRecordCount,
                            filter_query: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&build_filter_tree=true&${prepareShopifyUrl(query)}`
                        });
                    }
                }
                dispatch({type: `${event_type}_LOADED`});
            })
            .catch((error) => appErrorLogger('Get Similar', error))
    }
};

const getSimilarFromBE = (query, product_id, event_type) => {
    return (dispatch, getState) => {
        rebag_products_instance.get(`?${query}&via_gb=1`)
            .then((response) => {
                const {products, total_products} = response.data;
                if(products.length > 0){
                    const filtered_products = removeCurrent(products, product_id);
                    if(filtered_products.length > 0){
                        dispatch({
                            type: event_type,
                            products: ModelProductList(products.slice(0, item_limit)),
                            total_products: total_products,
                            filter_query: `${config.host_rebag_shop}/collections/new-arrivals?_=pf&build_filter_tree=true&${prepareShopifyUrl(query)}`
                        });
                    }
                }
                dispatch({type: `${event_type}_LOADED`});
            })
            .catch((error) => appErrorLogger('Get Similar', error))
    }
}

const removeCurrent = (products, current_product_id) => {
    return _.filter(products, (product) => {return current_product_id !== product.id});
};

const getItemsFromBC = (saved_search) => {
    return (dispatch, getState) => {
        const api_client = getState().appReducer.isBoostDown ? rebag_products_instance : groupByInstance;
        const user_profile = getState().myAccountReducer.user_profile;
        const queryArray = decodeURIComponent(saved_search.bc_url).replaceAll('[]', '').replaceAll('bc-sf-filter/filter?', '').replaceAll('bc-sf-filter/search?', '').split('&');
        const payload = {
            collection: config.gb_collection,
            area: config.gb_area,
            skip: "0",
            query: '',
            refinements: [],
            sorts: [],
            preFilter: "attributes.publishedOnChannel:ANY(\"true\") AND availability:ANY(\"IN_STOCK\") AND NOT attributes.tags:ANY(\"pfs:hidden\")",
            pageCategories: ["new-arrivals"],
            pageSize: item_limit
        }
        if (user_profile && user_profile.shopify_id) {
            payload.loginId = user_profile.shopify_id;
        }

        queryArray.forEach(item => {
            const [filterId, filterValue] = item.split('=');
            if (filterId === 'pf_st_availability_hidden') {
                return
            }

            if (filterId === 'q') {
                payload.query = filterValue;
                return
            }

            if (filterId === 'pf_t_first_look_hidden') {
                payload.preFilter += ` AND attributes.pf_t_first_look_hidden:ANY("${filterValue}")`;
                return
            }

            if (filterId === 'h_options') {
                payload.preFilter += ` AND NOT attributes.tags:ANY("${filterValue}")`;
                return
            }

            if (filterId === 'collection_scope' && parseInt(filterValue) > 0) {
                payload.preFilter += ` AND attributes.collectionIds:ANY("${filterValue}")`;
                return
            }

            payload.refinements.push({
                displayName: filterValue,
                navigationName: `attributes.${filterId}`,
                or: "true",
                type: "Value",
                value: filterValue,
            })
        })
        //we check against the list of filters and we remove other unsupported query params and we add it to the payload
        payload.refinements = payload.refinements.filter(refinement => config.plpFilters[refinement.navigationName.replace('attributes.', '')]);

        api_client.post('', JSON.stringify(payload))
            .then((response) => {
                const {records, totalRecordCount} = response.data;
                dispatch({
                    type: "SET_SAVED_SEARCH_ITEMS",
                    products: ModelProductList(records),
                    total_products: totalRecordCount,
                    search_id: saved_search.id,
                    saved_search: saved_search
                });
            })
            .catch((error) => {
                appErrorLogger('get saved searches my account', error)
                dispatch({
                    type: "SET_SAVED_SEARCH_ITEMS",
                    products: [],
                    total_products: 0,
                    search_id: saved_search.id,
                    saved_search: saved_search
                });
            })
    }
}

const getProductsByURLFromBE = (url) => {
    const url_params = url.split("?")[1];
    const url_params_arr = (url_params && url_params.split("&")) || 0;
    let url_processed = url_params;

    for (let x=0; x<url_params_arr.length; x++) {
        if (url_params_arr[x].match(/pf_.+=/)) {
            const param_with_added_brackets = url_params_arr[x].replace("=", "[]=");
            url_processed = url_processed.replace(url_params_arr[x], param_with_added_brackets)
        }
    }

    return rebag_products_instance.get(`/?limit=${item_limit}&${url_processed}&cagrby=1&via_gb=1`, )
        .then((response) => {
            const {products, total_product} = response.data;
            if(total_product > 0){
                return {
                    products: ModelProductList(products),
                    total_products: total_product
                };
            } else {
                return {}
            }
        })
        .catch((error) => {
            appErrorLogger('Get Products By URL', error)
            return {
                products: [],
                total_products: 0
            }
        })
}


const getProductsByURL = (url, scope) => {
    const queryArray =  decodeURIComponent(url).replaceAll('[]', '').split('&');
    const payload = {
        collection: config.gb_collection,
        area: config.gb_area,
        skip: "0",
        query: '',
        refinements: [],
        sorts: [],
        preFilter: "attributes.publishedOnChannel:ANY(\"true\") AND availability:ANY(\"IN_STOCK\") AND NOT attributes.tags:ANY(\"pfs:hidden\")",
        pageCategories: ["new-arrivals"],
        pageSize: item_limit
    }
    queryArray.forEach(item => {
        const [filterId, filterValue] = item.split('=');
        if (filterId === 'pf_st_availability_hidden') {
            return
        }

        if (filterId === 'q') {
            payload.query = filterValue;
            return
        }

        if (filterId === 'pf_t_first_look_hidden') {
            payload.preFilter += ` AND attributes.pf_t_first_look_hidden:ANY("${filterValue}")`;
            return
        }

        if (filterId === 'h_options') {
            payload.preFilter += ` AND NOT attributes.tags:ANY("${filterValue}")`;
            return
        }

        payload.refinements.push({
            displayName: filterValue,
            navigationName: `attributes.${filterId}`,
            or: "true",
            type: "Value",
            value: filterValue,
        })
    })

    if (scope && parseInt(scope) > 0) {
        payload.preFilter += ` AND attributes.collectionIds:ANY("${scope}")`;
    }
    //we check against the list of filters and we remove other unsupported query params and we add it to the payload
    payload.refinements = payload.refinements.filter(refinement => config.plpFilters[refinement.navigationName.replace('attributes.', '')]);

    return groupByInstance.post('', JSON.stringify(payload))
        .then((response) => {
            const {records, totalRecordCount} = response.data;
            if(totalRecordCount > 0){
                return {
                    products: ModelProductList(records),
                    total_products: totalRecordCount
                };
            } else {
                return {}
            }
        })
        .catch((error) => {
            appErrorLogger('Get Products By URL', error)
            return {
                products: [],
                total_products: 0
            }
        })
}

const getProductsByCollectionFromBE = (filter_name, collection, sort='extra-sort1-descending', isBoostDown) => {
    return rebag_products_instance.get(`/?${filter_name}[]=${collection}&limit=${item_limit}&pf_st_availability_hidden[]=true&cagrby=1&via_gb=1`, )
        .then((response) => {
            const {products, total_product} = response.data;
            if(total_product > 0){
                return {
                    products: ModelProductList(products),
                    total_products: total_product,
                    collection: collection
                };
            } else {
                return {}
            }
        })
        .catch((error) => {
            appErrorLogger('Get Products By Collection', error)
            return {
                products: [],
                total_products: 0,
                collection: collection
            };
        })

}

const getProductsByCollection = (filter_name, collection, sort='extra-sort1-descending', isBoostDown) => {
    const api_client = isBoostDown ? rebag_products_instance : groupByInstance;
    const payload = {
        collection: config.gb_collection,
        area: config.gb_area,
        skip: "0",
        query: "",
        refinements: [
            {
                "type": "Value",
                "navigationName": `attributes.${filter_name}`,
                "value": collection,
                "displayName": collection,
                "or": "true"
            }
        ],
        sorts: [],
        preFilter: "attributes.publishedOnChannel:ANY(\"true\") AND NOT attributes.tags:ANY(\"pfs:hidden\") AND availability:ANY(\"IN_STOCK\")",
        pageCategories: ["new-arrivals"],
        pageSize: item_limit
    };
    //we remove the sort from the query params and we add it to the payload
    const groupBySort = getGroupBySortObject(sort);

    if (!_.isEmpty(groupBySort)) {
        payload.sorts.push(groupBySort);
    }

    return api_client.post('', JSON.stringify(payload))
      .then((response) => {
          const {records, totalRecordCount} = response.data;
          if(totalRecordCount > 0){
              return {
                  products: ModelProductList(records),
                  total_products: totalRecordCount,
                  collection: collection
              };
          } else {
              return {}
          }
      })
      .catch((error) => {
          appErrorLogger('Get Products By Collection', error)
          return {
              products: [],
              total_products: 0,
              collection: collection
          };
      })
}

const getLabeledCollections = () => {
    return (dispatch, getState) => {
        const labeled_collections = {};
        let retrieved_collections = 0;

        if(!localStorage.getItem('init')){
            setTimeout(() => dispatch(getLabeledCollections()), 3000);
        } else {
            const init = JSON.parse(localStorage.getItem('init'));
            const {user_profile} = getState().myAccountReducer;
            let collections = init['extra_tags_map'];
            if (!user_profile || (user_profile && !canSeeFirstLook(user_profile))) {
                delete collections["bc-filter-extra-tags-First Look"];
            }

            _.map(collections, (collection, collection_filter_key) => {
                labeled_collections[collection_filter_key] = {};
                dispatch(getProductsByTag(collection_filter_key))
                    .then((products) => {
                        retrieved_collections++;
                        labeled_collections[collection] = {
                            products: products,
                            total_products: products.length,
                            collection: collection,
                            collection_filter_key: collection_filter_key
                        }

                        if(retrieved_collections === Object.keys(collections).length){
                            dispatch({
                                type: 'SET_LABELED_COLLECTIONS',
                                labeled_collections: labeled_collections
                            })
                        }
                    })
                    .catch((error) => appErrorLogger('Get Labeled Collection', error))
            });
        }
    }
}

const getStyleAssemblyCollections = () => {
    return (dispatch, getState) => {
        const style_assembly_collections = {};
        let retrieved_collections = 0;
        const collections = extractStyleAssemblyCollectionsMapFromConfig();
        if (_.isEmpty(collections)) {
            setTimeout(() => dispatch(getStyleAssemblyCollections()), 3000);
        } else {
            _.map(collections, (collection, collection_filter_key) => {
                style_assembly_collections[collection_filter_key] = {};
                getProductsByCollectionFromBE('pf_t_collections', collection_filter_key, 'created-descending', getState().appReducer.isBoostDown)
                    .then((response) => {
                        retrieved_collections++;
                        style_assembly_collections[collection] = {
                            products: response.products,
                            total_products: response.total_products,
                            collection: collection,
                            collection_filter_key: collection_filter_key
                        }

                        if (retrieved_collections === Object.keys(collections).length) {
                            dispatch({
                                type: 'SET_STYLE_ASSEMBLY_COLLECTIONS',
                                style_assembly_collections: style_assembly_collections
                            })
                        }
                    });
            });
        }
    }
}

const getActiveCollections = () => {
    return (dispatch, getState) => {
        const new_curated_collections = {};
        let retrieved_collections = 0;
        const collections = extractOptionFromBC('pf_t_collections');
        if (_.isEmpty(collections)) {
            setTimeout(() => dispatch(getActiveCollections()), 3000);
        } else {
            _.map(collections.manualValues, (collection) => {
                new_curated_collections[collection] = {};
                dispatch(getProductsByTag(collection)).then((products) => {
                    retrieved_collections++;
                    new_curated_collections[collection] = {
                        products: products,
                        total_products: products.length,
                        collection: collection
                    }

                    if (retrieved_collections === collections.manualValues.length) {
                        dispatch({
                            type: 'SET_CURATED_COLLECTIONS',
                            curated_collections: new_curated_collections
                        })
                    }
                });
            });
        }
    };
}

const getNewArrivalsCollection = () => {
    return (dispatch, getState) => {
        getProductsByURLFromBE("/collections/new-arrivals",'0', getState().appReducer.isBoostDown).then((response) => {
            dispatch({
                type: 'SET_NEW_ARRIVALS_COLLECTION',
                payload: response.products
            })
        });
    }
}

const getObjFromBCInit = (key) => {
    return (dispatch, getState) => {
        const products_from_bc_init = extractObjFromBC(key);
        if(_.isEmpty(products_from_bc_init)){
            setTimeout(() => dispatch(getObjFromBCInit(key)), 3000);
        } else {
            dispatch({
                type: 'GET_PRODUCTS_FROM_BC_INIT',
                products_from_bc_init: ModelProductList(products_from_bc_init)
            })
        }
    }
}

const getTrendingCollection = () => {
    return (dispatch, getState) => {
        getProductsByCollectionFromBE('pf_t_extra_tags_hidden', 'bc-filter-extra-tags-trending', 'created-descending', getState().appReducer.isBoostDown).then((response) => {
            dispatch({
                type: 'SET_TRENDING_COLLECTION',
                trending_collection: response
            })
        });
    }
}

const getCustomCollection = (url, scope) => {
    return (dispatch, getState) => {
        getProductsByURLFromBE(url, scope, getState().appReducer.isBoostDown).then((response) => {
            dispatch({
                type: 'SET_CUSTOM_COLLECTION_SLIDE',
                vault_custom_collection: response
            })
        });
    }
}

const extractObjFromBC = (key) => {
    if (window.initObj && window.initObj[key]) {
        return window.initObj[key];
    }

    return [];
};

const getFilterTree = () => {
    return (dispatch, getState) => {
        const api_client = getState().appReducer.isBoostDown ? rebag_filter_instance : groupByInstance;
        const {selectedCountry, init } = getState().appReducer;
        const {user_profile} = getState().myAccountReducer;
        const payload = {
            collection: config.gb_collection,
            area: config.gb_area,
            skip: "0",
            query: "",
            refinements: [],
            sorts: [],
            preFilter: "attributes.publishedOnChannel:ANY(\"true\") AND NOT attributes.tags:ANY(\"pfs:hidden\") AND availability:ANY(\"IN_STOCK\")",
            pageCategories: ["new-arrivals"],
            pageSize: 48
        };
        if (user_profile && user_profile.shopify_id) {
            payload.loginId = user_profile.shopify_id;
        }
        //we remove the sort from the query params and we add it to the payload
        return new Promise (async (resolve) => {
            api_client.post('', JSON.stringify(payload))
              .then((response) => {
                  const {groupByUpdatedFilters} = groupByUpdateFilters(response.data.availableNavigation, selectedCountry, init, user_profile);
                  dispatch({
                      type: 'SET_BC_FILTER_TREE',
                      payload: groupByUpdatedFilters
                  })
                  resolve();
              })
              .catch(() => {
                  rebag_filter_instance.get(`/?shop=${config.bc_shop}&page=1&limit=1&build_filter_tree=true`)
                    .then((response) => {
                        dispatch({
                            type: 'SET_BC_FILTER_TREE',
                            payload: response.data.filter.options
                        })
                        resolve();
                    })
                    .catch((error) => {
                        appErrorLogger('Get Filter Tree', error);
                        resolve();
                    })
              })
        })
    }
}

const getPdpVariants = (refinements, isBoostDown, inStock) => {
    const payload = {
        collection: config.gb_collection,
        area: config.gb_area,
        skip: "0",
        query: "",
        refinements: refinements,
        sorts: [],
        preFilter: "attributes.publishedOnChannel:ANY(\"true\") AND NOT attributes.tags:ANY(\"pfs:hidden\")",
        pageCategories: ["new-arrivals"],
        pageSize: 14
    };
    if (inStock) {
        payload.preFilter += " AND availability:ANY(\"IN_STOCK\")";
    }

    const apiClient = isBoostDown ? rebag_products_instance : groupByInstance;
    return apiClient.post('', JSON.stringify(payload))
}

const getPdpVariantsFromBE = (url) => {
    const url_params = url.split("?")[1];
    const url_params_arr = (url_params && url_params.split("&")) || 0;
    let url_processed = url_params;

    for (let x = 0; x < url_params_arr.length; x++) {
        if (url_params_arr[x].match(/pf_.+=/)) {
            const param_with_added_brackets = url_params_arr[x].replace("=", "[]=");
            url_processed = url_processed.replace(url_params_arr[x], param_with_added_brackets)
        }
    }
    return rebag_products_instance.get(`/?${url_processed}&limit=48&pf_t_first_look_hidden%5B%5D=bc-filter-General+View&cagrby=1&via_gb=1`)
}

const setPdpVariantsFromBE = (product_designer, product_model, product_style, product_size, label, event) => {
    return (dispatch, getState) => {
        const all_products_url = `?pf_v_designers=${product_designer}&pf_st_availability_hidden=true&pf_t_categories=bc-filter-Bags&pf_t_model=${product_model}&pf_t_style=${product_style}${product_size ? '&pf_t_bag_size=' + product_size : ''}`
        getPdpVariantsFromBE(all_products_url, getState().appReducer.isBoostDown)
            .then((response) => {
                const labelObj = response.data.filter.options.filter((el) => {
                    return label === el.label
                })
                const all_label_variants = labelObj[0] ? labelObj[0].values : [];
                const all_label_variants_products = response.data.products;
                dispatch({
                    type: `SET_${event.toUpperCase()}_VARIANTS`,
                    all_label_variants: all_label_variants,
                    all_label_variants_products: all_label_variants_products,
                    available_label_variants: labelObj[0] ? labelObj[0].values : [],
                    available_label_variants_products: response.data.products,
                })
            })
            .catch((error) => {
                dispatch({
                    type: `SET_${event.toUpperCase()}_VARIANTS`,
                    all_label_variants: [],
                    all_label_variants_products: [],
                    available_label_variants: [],
                    available_label_variants_products: [],
                })
                appErrorLogger('Get PDP Available Variants:' + label, error)
            })
    }
}

const setPdpVariants = (product_designer, product_model, product_style, product_size, label, event) => {
    return (dispatch, getState) => {
        const refinements = [
            {
                "type": "Value",
                "navigationName": `attributes.pf_v_designers`,
                "value": product_designer,
                "displayName": product_designer,
                "or": "true"
            },
            {
                "type": "Value",
                "navigationName": `attributes.pf_t_categories`,
                "value": 'bc-filter-Bags',
                "displayName": 'bc-filter-Bags',
                "or": "true"
            },
            {
                "type": "Value",
                "navigationName": `attributes.pf_t_model`,
                "value": product_model,
                "displayName": product_model,
                "or": "true"
            },
            {
                "type": "Value",
                "navigationName": `attributes.pf_t_style`,
                "value": product_style,
                "displayName": product_style,
                "or": "true"
            },
        ]
        if (product_size) {
            refinements.push({
                "type": "Value",
                "navigationName": `attributes.pf_t_bag_size`,
                "value": product_size,
                "displayName": product_size,
                "or": "true"
            })
        }
        getPdpVariants(refinements, getState().appReducer.isBoostDown, true)
            .then((response) => {
                const selectedFilter = response.data.availableNavigation.filter((el) => {
                    return label === el.displayName
                })[0];
                if(selectedFilter) {
                    selectedFilter.refinements.map(filterOption => {
                        filterOption.key= filterOption.value;
                        filterOption.doc_count= filterOption.count;
                        return filterOption
                    })
                    selectedFilter.values = selectedFilter.refinements;
                    selectedFilter.label = selectedFilter.displayName;
                }
                dispatch({
                    type: `SET_${event.toUpperCase()}_VARIANTS`,
                    all_label_variants: [],
                    all_label_variants_products: [],
                    available_label_variants: selectedFilter ? selectedFilter.values : [],
                    available_label_variants_products: response.data.records,
                })
            })
            .catch((error) => {
                dispatch({
                    type: `SET_${event.toUpperCase()}_VARIANTS`,
                    all_label_variants: all_label_variants,
                    all_label_variants_products: all_label_variants_products,
                    available_label_variants: [],
                    available_label_variants_products: [],
                })
                appErrorLogger('Get PDP Available Variants:' + label, error)
            })

    }
}

const getGroupByProducts = (data) => {
    return groupByInstance.post('', JSON.stringify(data))
}

const handleUpdatePlpProducts = (setPlpLoaded) => {
    return (dispatch) => {
        const urlParams = new URLSearchParams(window.location.search);
        const isFirstPage = !urlParams.get('page') || urlParams.get('page') === "1";
        const can_see_first_look_items = authCheck() && getCookie("can_see_first_look") === "true";
        const insertFirstLookPreviewProducts = !can_see_first_look_items && !isSearchUrl();
        const {must_show_navbar_message} = vipPreviewTimers();

        if (insertFirstLookPreviewProducts && isFirstPage && config.bc_new_arrivals_collection_scope === window.collectionScope && !must_show_navbar_message) {
            dispatch(updatePlpProducts({"pf_t_first_look_hidden[]": "bc-filter-extra-tags-First Look"}, 2))
              .then((response) => {
                let forceProductLimit = response?.length > 0 ? 46 : 48;
                dispatch(updatePlpProducts({"pf_t_first_look_hidden[]": "bc-filter-General View"}, forceProductLimit))
                    .then(() => {
                        setPlpLoaded();
                    });
            });
        } else {
            dispatch({
                type: 'SET_FIRST_LOOK_PRODUCTS',
                payload: [],
            });
            dispatch(updatePlpProducts(!can_see_first_look_items ? {"pf_t_first_look_hidden[]": "bc-filter-General View"} : null))
                .then(() => {
                    setPlpLoaded();
                });
        }
    }
}

const updatePlpProducts = (forceAdditionalParamObj, forceProductNrLimit) => {
    return (dispatch, getState) => {
        return new Promise (async (resolve) => {
            const searchParams = new URL(window.location.href).searchParams;
            const { paramsString, groupByRefinements } = memoizedGetParamsString(forceAdditionalParamObj, forceProductNrLimit, searchParams);
            const forceAdditionalParamValue = forceAdditionalParamObj && forceAdditionalParamObj[Object.keys(forceAdditionalParamObj)[0]];
            const {selectedCountry, init, mobile_medium, isInternational, isUsdInternational} = getState().appReducer;
            const nonUsd = isInternational ? !isUsdInternational : false;
            const {user_profile} = getState().myAccountReducer;
            const {firstLookProducts} = getState().shopifyReducer;
            const buildGroupByPayload = getBuildGroupByPayload(groupByRefinements, forceAdditionalParamObj, forceProductNrLimit, user_profile);

            try {
                appInfoLogger('GroupBy Call Payload', {message: JSON.stringify(buildGroupByPayload)});
                const searchRefinement = groupByRefinements.find(refinement => refinement.navigationName === 'attributes.q');
                const groupByProducts = (user_profile || searchRefinement) ? await getGroupByProducts(buildGroupByPayload) : await rebag_products_instance.get(`/?${paramsString}&gbdr=1&via_gb=1`);
                const {groupByAppliedFilters, groupByUpdatedFilters} = groupByUpdateFilters(groupByProducts.data.availableNavigation, selectedCountry, init, user_profile);
                if (forceAdditionalParamValue === "bc-filter-extra-tags-First Look") {
                    const adjustedProducts = groupByProducts.data.records.length !== 0 ? groupByProducts.data.records.map(value => {
                        value.firstLookProduct = true;
                        return value;
                    }) : [];
                    dispatch({
                        type: 'SET_FIRST_LOOK_PRODUCTS',
                        payload: adjustedProducts,
                    });
                    resolve(adjustedProducts);
                } else {
                    if (groupByProducts.data.records.length < 12 ) {
                        window.scrollTo(0, 0);
                    }
                    setCookie('searchAttributionToken', groupByProducts.data.metadata.searchAttributionToken);
                    setCookie('searchId', groupByProducts.data.id);
                    sendPlpGroupBySearchEvent(groupByProducts.data.records, firstLookProducts, mobile_medium, groupByAppliedFilters.filter(filter => filter.key !== 'searchString'), nonUsd);
                    dispatch({
                        type: 'SET_ALL_PRODUCTS',
                        payload: {
                            products: groupByProducts.data.records,
                            plpTotalProducts: groupByProducts.data.totalRecordCount,
                        },
                    });
                    dispatch({
                        type: 'SET_BC_FILTER_TREE',
                        payload: groupByUpdatedFilters,
                    });
                    dispatch({
                        type: 'SET_APPLIED_FILTERS',
                        payload: groupByAppliedFilters,
                    });
                    resolve();
                }
            } catch (error) {
                dispatch({type: "HIDE_SPINNER"});
                axios.get(`${config.host_rebag_api}/v6/initial-data/`)
                  .then((response) => {
                      const init = {...response.data};
                      appErrorLogger('react-plp groupBy get products boost api failing', error, {apiInitialData: init});
                  })
                  .catch(function (error) {
                      appErrorLogger('react-plp groupBy get products boost + initial data api failing', error);
                  });
                resolve();
            }
        })
    }
}

const filterBlockOptionClick = (filterBlock, filterBlockOption) => {
    return (dispatch) => {
        dispatch({type: "SHOW_SPINNER"});
        handleQueryParam(filterBlock.filterOptionId, filterBlockOption.key, filterBlockOption.optionSelected);
        dispatch(handleUpdatePlpProducts(() => dispatch({type: "HIDE_SPINNER"})));
    }
}

const handleQueryParam = (key, value, optionSelected) => {
    const newUrl = new URL(window.location.href);
    const params = new URLSearchParams(newUrl.search);
    if (optionSelected) {
        const updatedParams = [];
        for (const [paramKey, paramValue] of params) {
            if (paramKey !== key || paramValue !== value) {
                updatedParams.push([paramKey, paramValue]);
            }
        }
        newUrl.search = updatedParams.map(([key, value]) => `${key}=${value}`).join('&');
    } else {
        newUrl.searchParams.append(key, value);
    }
    if(newUrl.searchParams.has('page')) {
        newUrl.searchParams.delete('page');
    }
    window.history.pushState({}, '', newUrl.toString());
}

const setTrendingPopularSearches = (mobile) => {
    return async (dispatch) => {
        const trendingSearchesResponse = await getTrendingSearches();
        const popularBagsResponse = await getPopularBags();
        dispatch({
            type: 'SET_TRENDING_SEARCHES',
            payload: mobile ? trendingSearchesResponse.data.default_designers.slice(0, 4) : trendingSearchesResponse.data.default_designers,
        });
        dispatch({
            type: 'SET_POPULAR_BAGS',
            payload: popularBagsResponse.data.slice(0, 3),
        })
    }
}

const getTrendingSearches = _.memoize(() => {
    return axios.get(`${config.host_rebag_api}/v6/meta/trending-searches/`)
      .catch((errors) => appErrorLogger('Get Trending Searches', errors))
})

const getPopularBags = _.memoize(() => {
    return axios.get(`${config.host_rebag_api}/v6/meta/popular-bags/`)
      .catch((errors) => appErrorLogger('Get Popular Bags', errors))
})

const setDefaultSearchResults = (mobile, setIsLoading) => {
    return async (dispatch) => {
        setIsLoading(true);
        try {
            const [defaultSearchesResponse, defaultSearchProducts] = await Promise.all([getDefaultSearches(), getDefaultSearchProducts()]);
            const updatedDefaultSearches = defaultSearchesResponse.data.default_designers.map(defaultSearch => {
              defaultSearch.search_url = `/collections/all-bags?_=pf&pf_st_availability_hidden=true&pf_v_designers=${defaultSearch.title}`
              return defaultSearch
            })
            dispatch({
                type: 'SET_DEFAULT_DESIGNERS',
                payload: updatedDefaultSearches,
            })
            dispatch({
                type: 'SET_DEFAULT_SEARCH_TERMS',
                payload: mobile ? defaultSearchesResponse.data.default_searches.slice(0, 4) : defaultSearchesResponse.data.default_searches,
            });
            dispatch({
                type: 'SET_DEFAULT_SEARCH_PRODUCTS',
                payload: ModelProductList(defaultSearchProducts.data),
            });
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            appErrorLogger('Set Default Search Results', error);
        }
    }
}

const getDefaultSearches = _.memoize(() => {
    return axios.get(`${config.host_rebag_api}/v6/meta/trending-searches/`)
      .catch((errors) => appErrorLogger('Get Default Searches', errors))
})

const getDefaultSearchProducts = _.memoize(() => {
    return axios.get(`${config.host_rebag_api}/v6/meta/popular-bags/`)
      .catch((errors) => appErrorLogger('Get Default Search Products', errors))
})

const getGroupBySearches = async (searchValue) => {
  const url = `https://proxy.rebag.groupbycloud.com/rebag/api/request?collection=ProductsProduction&area=ProductionRb&searchItems=8&query=${searchValue}`;
    if (cancelSearchPreviousRequest) {
        cancelSearchPreviousRequest();
    }

    appInfoLogger('GroupBy Search Term', {message: JSON.stringify(searchValue)});
    return autocompleteGroupByInstance.get(url, {
        cancelToken: new axios.CancelToken(function executor(c) {
            cancelSearchPreviousRequest = c;
        }),
    })
}

const getGroupBySearchProducts = (searchValue, user_profile) => {
    const data = {
        collection: config.gb_collection,
        area: config.gb_area,
        skip: "0",
        query: searchValue,
        refinements: [],
        sorts: [],
        preFilter: "attributes.publishedOnChannel:ANY(\"true\") AND availability:ANY(\"IN_STOCK\") AND NOT attributes.tags:ANY(\"pfs:hidden\")",
        pageCategories: ["new-arrivals"],
        pageSize: 6
    }

    if (user_profile && user_profile.shopify_id) {
        data.loginId = user_profile.shopify_id;
    }

    appInfoLogger('GroupBy Search Payload', {message: JSON.stringify(data)});
    return groupByInstance.post('', JSON.stringify(data), {
        cancelToken: new axios.CancelToken(function executor(c) {
            cancelSearchPreviousRequest = c;
        }),
    })
}

const getGroupBySearchProductsOld = (searchValue) => {
    const data = {
        collection: config.gb_collection,
        area: config.gb_area,
        skip: "0",
        query: searchValue,
        refinements: [],
        sorts: [],
        preFilter: "attributes.publishedOnChannel:ANY(\"true\") AND availability:ANY(\"IN_STOCK\") AND NOT attributes.tags:ANY(\"pfs:hidden\")",
        pageCategories: ["new-arrivals"],
        pageSize: 3
    }

    appInfoLogger('GroupBy Search Payload', {message: JSON.stringify(data)});
    return groupByInstance.post('', JSON.stringify(data), {
        cancelToken: new axios.CancelToken(function executor(c) {
            cancelSearchPreviousRequest = c;
        }),
    })
}

const debouncedSuggestedSearches = (...args) => (dispatch, getState) => setSuggestedSearches(dispatch, getState, ...args);

const setSuggestedSearches = _.debounce(async (dispatch, getState, isApiSubscribed, searchValue, setIsLoading) => {
    if (searchValue) {
        if (isApiSubscribed) {
            try {
                setIsLoading(true);
                const suggestedSearches = await getGroupBySearches(searchValue);
                const searchPayload = suggestedSearches.data.searchTerms ? suggestedSearches.data.searchTerms[0].value : searchValue;
                const suggestedProducts = await getGroupBySearchProducts(searchPayload, getState().myAccountReducer.user_profile);
                const mapSearchResults = mapGroupBySearch(suggestedSearches.data.searchTerms || [], ModelProductList(suggestedProducts.data.records));
                const suggestedDesigners = [];
                suggestedSearches.data.searchTerms && suggestedSearches.data.searchTerms.forEach((term) => {
                  term.additionalInfo && term.additionalInfo.brands.forEach((brand) => {
                    suggestedDesigners.push({
                      title: brand,
                      search_url: `/search?q=${searchValue}&pf_v_designers=${brand}`,
                    })
                  })
                })
                dispatch({
                    type: 'SET_SUGGESTED_DESIGNERS',
                    payload: _.uniq(suggestedDesigners, (designer) => designer.title).slice(0, 8),
                })
                dispatch({
                    type: 'SET_SEARCH_PRODUCT_RESULTS',
                    payload: mapSearchResults.mappedProducts,
                })
                dispatch({
                    type: 'SET_SUGGESTED_SEARCH_TERMS',
                    payload: mapSearchResults.mappedSuggestedSearches,
                })
                dispatch({
                    type: 'SET_SEARCH_TOTAL_PRODUCTS',
                    payload: suggestedProducts.data.totalRecordCount,
                })
                setIsLoading(false);
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled', error.message);
                } else {
                    // Handle error and possibly dispatch failure action
                    dispatch({
                        type: 'SET_SEARCH_PRODUCT_RESULTS',
                        payload: [],
                    })
                    dispatch({
                        type: 'SET_SUGGESTED_SEARCH_TERMS',
                        payload: [],
                    })
                    dispatch({
                        type: 'SET_SEARCH_TOTAL_PRODUCTS',
                        payload: [],
                    })
                    appErrorLogger('react-plp get search groupBy api failing', error);
                }
                setIsLoading(false);
            }
        }
    } else {
        dispatch({
            type: 'SET_SEARCH_PRODUCT_RESULTS',
            payload: [],
        })
        dispatch({
            type: 'SET_SUGGESTED_SEARCH_TERMS',
            payload: [],
        })
        dispatch({
            type: 'SET_SEARCH_TOTAL_PRODUCTS',
            payload: 0,
        })
    }
}, config.searchDebounceValue);

const debouncedSuggestedSearchesOld = (...args) => (dispatch, getState) => setSuggestedSearchesOld(dispatch, getState, ...args);

const setSuggestedSearchesOld = _.debounce(async (dispatch, getState, isApiSubscribed, searchValue) => {
    if (searchValue) {
        if (isApiSubscribed) {
            try {
                const suggestedSearches = await getGroupBySearches(searchValue);
                const searchPayload = suggestedSearches.data.searchTerms ? suggestedSearches.data.searchTerms[0].value : searchValue;
                const suggestedProducts = await getGroupBySearchProductsOld(searchPayload);
                const mapSearchSuggestions = mapGroupBySearchOld(suggestedSearches.data.searchTerms || [], ModelProductList(suggestedProducts.data.records));

                dispatch({
                    type: 'SET_SEARCH_TOP_MATCHES',
                    payload: mapSearchSuggestions.mappedSearchTopMatches,
                })
                dispatch({
                    type: 'SET_SEARCH_DESIGNERS_COLLECTIONS',
                    payload: mapSearchSuggestions.mappedSearchTerms,
                })
                dispatch({
                    type: 'SET_SEARCH_TOTAL_PRODUCTS',
                    payload: suggestedProducts.data.totalRecordCount,
                })
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled', error.message);
                } else {
                    // Handle error and possibly dispatch failure action
                    dispatch({
                        type: 'SET_SEARCH_TOP_MATCHES',
                        payload: [],
                    })
                    dispatch({
                        type: 'SET_SEARCH_DESIGNERS_COLLECTIONS',
                        payload: [],
                    })
                    dispatch({
                        type: 'SET_SEARCH_TOTAL_PRODUCTS',
                        payload: [],
                    })
                    appErrorLogger('react-plp get search groupBy api failing', error);
                }
            }
        }
    } else {
        dispatch({
            type: 'SET_SEARCH_TOP_MATCHES',
            payload: [],
        })
        dispatch({
            type: 'SET_SEARCH_DESIGNERS_COLLECTIONS',
            payload: [],
        })
        dispatch({
            type: 'SET_SEARCH_TOTAL_PRODUCTS',
            payload: 0,
        })
    }
}, 450);

const setSavedSearchesModal = (value, type, filterString) => {
    return ({
        type: 'SHOW_SAVED_SEARCHES_MODAL',
        payload: {
            value,
            type,
            savedSearchInputValue: filterString,
        },
    })
}

const setSavedSearchInputValue = (value) => {
    return ({
        type: 'SET_SAVED_SEARCH_INPUT_VALUE',
        savedSearchInputValue: value,
    })
}

const handleChangeQuery = (queryName, queryValue) => dispatch => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const params = new URLSearchParams(url.search);
    if (params.has(queryName)) {
        params.set(queryName, queryValue);
    } else {
        params.append(queryName, queryValue);
    }
    url.search = params.toString();
    window.history.pushState({}, '', url.toString());
    dispatch({type: "SHOW_SPINNER"});
    dispatch(handleUpdatePlpProducts(() => dispatch({type: "HIDE_SPINNER"})));
}

const handleChangeQueries = (queryArray) => dispatch => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const params = new URLSearchParams(url.search);
    queryArray.forEach(query => {
        if (params.has(query.name)) {
            params.set(query.name, query.value);
        } else {
            params.append(query.name, query.value);
        }
    })
    url.search = params.toString();
    window.history.pushState({}, '', url.toString());
    dispatch({type: "SHOW_SPINNER"});
    dispatch(handleUpdatePlpProducts(() => dispatch({type: "HIDE_SPINNER"})));
}

const removeAppliedFilters = () => (dispatch, getState) => {
    //work in progress
    dispatch({type: "SHOW_SPINNER"});
    const { appliedFilters } = getState().shopifyReducer;
    const newUrl = new URL(window.location.href);
    const params = new URLSearchParams(newUrl.search);
    const updatedParams = [];
    const checkSearchUrl = isSearchUrl();
    for (const [paramKey, paramValue] of params) {
        if (!appliedFilters.find(filter => filter.key === paramValue || filter.key === 'searchString')) {
            updatedParams.push([paramKey, paramValue]);
        }
    }
    newUrl.search = updatedParams.map(([key, value]) => `${key}=${value}`).join('&');
    window.history.pushState({}, '', newUrl.toString());
    if (checkSearchUrl) {
        newUrl.pathname = '/collections/new-arrivals';
        window.location.href = newUrl.toString();
    } else {
        dispatch(handleUpdatePlpProducts(() => dispatch({type: "HIDE_SPINNER"})));
    }
}

const applyMobileFilters = (appliedFilter) => dispatch => {
    dispatch({type: "SHOW_SPINNER"});
    const newUrl = new URL(window.location.href);
    const params = new URLSearchParams(newUrl.search);
    const selectedValues = appliedFilter.values.filter(value => value.optionSelected);

    params.delete(appliedFilter.filterOptionId);
    selectedValues.forEach(selectedValue => {
        params.append(appliedFilter.filterOptionId, selectedValue.key);
    });
    if(params.has('page')) {
        params.delete('page');
    }
    newUrl.search = params.toString();
    window.history.pushState({}, '', newUrl.toString());
    dispatch(handleUpdatePlpProducts(() => dispatch({type: "HIDE_SPINNER"})));
}

const deleteQueryParam = (appliedFilterOption) => dispatch => {
    dispatch({type: "SHOW_SPINNER"});
    const newUrl = new URL(window.location.href);
    const params = new URLSearchParams(newUrl.search);
    let updatedParams = [];
    if(appliedFilterOption.key === 'searchString') {
        deleteSearchQueryParam();
    } else {
        for (const [paramKey, paramValue] of params) {
            if (paramKey !== appliedFilterOption.filterOptionId || paramValue !== appliedFilterOption.key) {
                updatedParams.push([paramKey, paramValue]);
            }
        }

        //we now delete other child filters that depend on this filter
        updatedParams = updatedParams.filter(updatedParam => {
            const childFilters = appliedFilterOption.remove[appliedFilterOption.key];
            if (childFilters) {
                return !childFilters.includes(updatedParam[0]);
            } else {
                return updatedParam
            }
        })
        newUrl.search = updatedParams.map(([key, value]) => `${key}=${value}`).join('&');
        window.history.pushState({}, '', newUrl.toString());
        dispatch(handleUpdatePlpProducts(() => dispatch({type: "HIDE_SPINNER"})));
    }
}

const deleteSearchQueryParam = () => {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('q');
    newUrl.pathname = '/collections/new-arrivals';
    newUrl.searchParams.set('_','pf');
    newUrl.searchParams.set('pf_st_availability_hidden', 'true');
    window.location.href = newUrl.toString();
}

const setForYouProducts = () => (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
        try {
            const user_profile = getState().myAccountReducer.user_profile;
            const forYouProductsResponse = await getForYouProducts(user_profile);
            const { forYouFilters, forYouProducts } = mapForYouProductsAndFilters(forYouProductsResponse.products);
            dispatch({
                type: "SET_FOR_YOU_PRODUCTS",
                payload: {
                    forYouFilters,
                    forYouProducts: ModelProductList(forYouProducts),
                }
            });
            resolve();
        } catch (error) {
            reject(error);
        }
    });
};

const getForYouProducts = (user_profile) => {
    const can_see_first_look_items = getCookie("can_see_first_look") === "true" ? 1 : 0;
    return new Promise((resolve, reject) => {
        axios.get(`${config.host_rebag_api}/v6/shop/personalized-recommendations/?email=${user_profile.email}&with_vip_preview=${can_see_first_look_items}`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                appErrorLogger("getForYouProducts", error);
                reject(error);
            });
    });
}

const setForYouAppliedFilters = (filterName, values) => (dispatch, getState) => {
    const products = getState().shopifyReducer.forYouProducts;
    let forYouAppliedFilters = getState().shopifyReducer.forYouAppliedFilters;
    forYouAppliedFilters = {...forYouAppliedFilters, [filterName]: values};

    dispatch({
        type: "SET_FOR_YOU_APPLIED_FILTERS",
        payload: {
            forYouAppliedFilters,
            forYouFilteredProducts: filterForYouProducts(products, forYouAppliedFilters),
        }
    })
}

const clearAllAppliedFilters = () => dispatch => {
    dispatch({
        type: "CLEAR_ALL_APPLIED_FILTERS",
        payload: {
            forYouAppliedFilters: {
              designers: [],
              categories: [],
              color: [],
              condition: [],
            },
            forYouFilteredProducts: []
        },
    });
}

export const callNewArrivalsForYouPopUp = () => {
    authenticatedAxios().get('/shop/new-arrivals-pop-up/')
      .catch(error => appErrorLogger('callNewArrivalsForYouPopUp', error));
}

export {
    getSimilar,
    getSimilarFromBE,
    getItemsFromBC,
    getLabeledCollections,
    getActiveCollections,
    getStyleAssemblyCollections,
    getTrendingCollection,
    getCustomCollection,
    getNewArrivalsCollection,
    getFilterTree,
    getObjFromBCInit,
    setPdpVariants,
    setPdpVariantsFromBE,
    getPdpVariants,
    updatePlpProducts,
    filterBlockOptionClick,
    setDefaultSearchResults,
    debouncedSuggestedSearches,
    debouncedSuggestedSearchesOld,
    setSavedSearchesModal,
    setSavedSearchInputValue,
    handleChangeQuery,
    removeAppliedFilters,
    handleUpdatePlpProducts,
    applyMobileFilters,
    deleteQueryParam,
    deleteSearchQueryParam,
    handleChangeQueries,
    setForYouProducts,
    setForYouAppliedFilters,
    clearAllAppliedFilters,
    setTrendingPopularSearches,
}